import { ModelSagres } from "@/types/model-sagres";
import { Municipio } from "../municipio";

export class Anexo extends ModelSagres {
  ID_ANEXO: string;
  DATA_CRIACAO: Date;
  USUARIO_ULT_ALTERACAO: string;
  NOME_ANEXO: string;
  FILEPATH: string;
  TAMANHO: number;
  TIPO: string;
  ID_NOVO_USUARIO: number;

  constructor(obj?: any) {
    super();
    if (obj) {
      if (obj.ID_ANEXO) this.ID_ANEXO = obj.ID_ANEXO;
      if (obj.DATA_CRIACAO) this.DATA_CRIACAO = new Date(obj.DATA_CRIACAO);
      if (obj.USUARIO_ULT_ALTERACAO) this.USUARIO_ULT_ALTERACAO = obj.USUARIO_ULT_ALTERACAO;
      if (obj.NOME_ANEXO) this.NOME_ANEXO = obj.NOME_ANEXO;
      if (obj.FILEPATH) this.FILEPATH = obj.FILEPATH;
      if (obj.TAMANHO) this.TAMANHO = obj.TAMANHO;
      if (obj.TIPO) this.TIPO = obj.TIPO;
      if (obj.ID_NOVO_USUARIO) this.ID_NOVO_USUARIO = obj.ID_NOVO_USUARIO;
    }
  }
}
